import { NgModule, Directive } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { FileSelectDirective } from 'ng2-file-upload';

import { UteButtonComponent } from './commons/atoms/ute-button/ute-buttons.component';
import { UteFabComponent } from './commons/atoms/ute-fab/ute-fab.component';
import { UteIconComponent } from './commons/atoms/ute-icon/ute-icon.component';
import { UteInputSquareComponent } from './commons/atoms/ute-input-square/ute-input-square.component';
import { UteSimpleCardComponent } from './commons/atoms/ute-simple-card/ute-simple-card.component';
import { UteInputComponent } from './commons/atoms/ute-input/ute-input.component';
import { UteRadioComponent } from './commons/atoms/ute-radio/ute-radio.component';
import { UteRadioGroupComponent } from './commons/atoms/ute-radio-group/ute-radio-group.component';
import { UteCheckboxComponent } from './commons/atoms/ute-checkbox/ute-checkbox.component';
import { UteCircleCheckboxComponent } from './commons/atoms/ute-circle-checkbox/ute-circle-checkbox.component';
import { UteLinkComponent } from './commons/atoms/ute-link/ute-link.component';
import { UteIconSpinnerComponent } from './commons/atoms/ute-icon-spinner/ute-icon-spinner.component';
import { UteToggleComponent } from './commons/atoms/ute-toggle/ute-toggle.component';
import { UteInputPrefixComponent } from './commons/atoms/ute-input-prefix/ute-input-prefix.component';
import { UteSignalWifiComponent } from './commons/atoms/ute-signal-wifi/ute-signal-wifi.component';

//molecules

import { UteCounterComponent } from './commons/molecules/ute-counter/ute-counter.component';
import { UteGenericListItem } from './commons/molecules/ute-generic-list-item/ute-generic-list-item.component';
import { UteGenericListItemGroup } from './commons/molecules/ute-generic-list-item-group/ute-generic-list-item-group.component';
import { UteActivitySmallItem } from './commons/molecules/ute-activity-small-item/ute-activity-small-item.component';
import { UteMenuDropdown } from './commons/molecules/ute-menu-dropdown/ute-menu-dropdown.component';
import { UteMenuItem } from './commons/molecules/ute-menu-item/ute-menu-item.component';
import { UteMenuItemGroup } from './commons/molecules/ute-menu-item-group/ute-menu-item-group.component';
import { UteIntroSlider } from './commons/molecules/ute-intro-slider/ute-intro-slider.component';
import { UteDrawerComponent } from './commons/molecules/ute-drawer/ute-drawer.component';
import { UteInputDrawerComponent } from './commons/molecules/ute-input-drawer/ute-input-drawer.component';
import { UteRenameModalComponent } from './commons/molecules/ute-rename-modal/ute-rename-modal.component';
import { UteToolbarComponent } from './commons/molecules/ute-toolbar/ute-toolbar.component';
import { UteModalDrawerComponent } from './commons/molecules/ute-modal-drawer/ute-modal-drawer.component';
import { UteTimepickerComponent } from './commons/molecules/ute-timepicker/ute-timepicker.component'
import { UteLoaderComponent } from './commons/atoms/ute-loader/ute-loader.component';
import { UteEmptyState } from './commons/molecules/ute-empty-state/ute-empty-state.component';
import { UteAvatarComponent } from './commons/molecules/ute-avatar/ute-avatar.component';
import { UteActionCard } from './commons/molecules/ute-action-card/ute-action-card.component';
import { UteCashCard } from './commons/molecules/ute-cash-card/ute-cash-card.component';


const components = [
  UteButtonComponent,
  UteFabComponent, 
  UteInputSquareComponent,
  UteIconComponent,
  UteSimpleCardComponent,
  UteInputComponent,
  UteRadioComponent,
  UteRadioGroupComponent,
  UteCheckboxComponent,
  UteCircleCheckboxComponent,
  UteLinkComponent,
  UteIconSpinnerComponent,
  UteToggleComponent,
  UteInputPrefixComponent,
  UteCounterComponent,
  UteGenericListItem,
  UteGenericListItemGroup,
  UteActivitySmallItem,
  UteMenuDropdown,
  UteMenuItem,
  UteMenuItemGroup,
  UteIntroSlider,
  UteDrawerComponent,
  UteInputDrawerComponent,
  UteTimepickerComponent,
  UteModalDrawerComponent,
  UteRenameModalComponent,
  UteLoaderComponent,
  UteEmptyState,
  UteSignalWifiComponent,
  UteToolbarComponent,
  UteAvatarComponent,
  UteActionCard,
  UteCashCard
];

@NgModule({
  imports: [
    IonicPageModule,
    TranslateModule.forChild()
  ],
  entryComponents: [
    UteTimepickerComponent
  ],
  declarations: [
    FileSelectDirective,
    ...components
  ],
  exports: components
})
@Directive({ selector: '[ng2FileDrop]' })
export class ComponentsModule {};



// WEBPACK FOOTER //
// ./src/app/components/components.module.ts